const ContentPublication = resolve =>
  require(['src/views/publication/ContentPublication'], resolve)
const PublicationBasicManage = resolve =>
  require(['src/views/publication/PublicationBasicManage'], resolve)
const PublicationPublishManage = resolve =>
  require(['src/views/publication/PublicationPublishManage'], resolve)
const MagazineModule = resolve =>
  require(['src/views/magazine/MagazineModule.vue'], resolve)
const MagazineCreate = resolve =>
  require(['src/views/magazine/MagazineCreate.vue'], resolve)
const MagazineManage = resolve =>
  require(['src/views/magazine/MagazineManage.vue'], resolve)
const MagazineBasicManage = resolve =>
  require(['src/views/magazine/MagazineBasicManage.vue'], resolve)
const MagazineContentManage = resolve =>
  require(['src/views/magazine/MagazineContentManage.vue'], resolve)
const MagazineCommentManage = resolve =>
  require(['src/views/magazine/MagazineCommentManage.vue'], resolve)
const TopicNotesManage = resolve =>
  require(['src/views/topic/TopicNotesManage.vue'], resolve)
// const User = resolve => require(['src/views/user/user.vue'], resolve)
const OrderManage = resolve =>
  require(['src/views/payment/OrderManage.vue'], resolve)
const UserAuthor = resolve =>
  require(['src/views/user/userAuthor.vue'], resolve)
const UserManage = resolve =>
  require(['src/views/user/UserManage.vue'], resolve)
const PublicationPageManage = resolve =>
  require(['src/views/page/PageManage'], resolve)
const TopicManage = resolve => require(['src/views/topic/TopicManage'], resolve)
const PromotionPage = resolve =>
  require(['src/views/promotion/promotion'], resolve)
const ReportPage = resolve => require(['src/views/report/report'], resolve)
const PushModule = resolve =>
  require(['src/views/push/PushModule.vue'], resolve)
const PushPage = resolve => require(['src/views/push/push.vue'], resolve)
const PushNewPage = resolve => require(['src/views/push/pushNew.vue'], resolve)
const AdsPage = resolve => require(['src/views/ads/Ads'], resolve)
const ProductPage = resolve => require(['src/views/product/product'], resolve)
const FormPage = resolve => require(['src/views/form/form'], resolve)
const ScorePage = resolve => require(['src/views/score/score'], resolve)
const SettingPage = resolve => require(['src/views/setting/Setting'], resolve)
const Resource = resolve =>
  require(['src/views/resource/ResourceManage'], resolve)
const BrandCase = resolve =>
  require(['src/views/brand/BrandCases.vue'], resolve)
const PublicationModule = resolve =>
  require(['src/views/publication/PublicationModule'], resolve)
const ThemePage = resolve => require(['src/views/theme/ThemePage.vue'], resolve)
const contentPublicationRouter = {
  path: '/content/:publicationId',
  component: PublicationModule,
  children: [
    {
      name: '内容小程序',
      path: '/content/:publicationId/',
      component: ContentPublication,
    },
    {
      name: '带播客功能带杂志小程序',
      path: '/content-podcast/:publicationId/',
      component: ContentPublication,
    },
    {
      path: '/content/:publicationId/create',
      component: MagazineCreate,
    },
    {
      path: '/content/:publicationId/basic',
      component: PublicationBasicManage,
    },
    {
      path: '/content/:publicationId/publish',
      component: PublicationPublishManage,
    },
    // page 的页面
    {
      name: '搭建页面',
      path: '/content/:publicationId/page',
      component: PublicationPageManage,
    },
    {
      name: '互动',
      path: '/content/:publicationId/topic',
      component: TopicManage,
    },
    // 评论管理
    {
      name: '全部评论管理',
      path: '/content/:publicationId/comment',
      component: MagazineCommentManage,
    },
    {
      name: '全部笔记管理',
      path: '/content/:publicationId/note',
      component: TopicNotesManage,
    },
    {
      name: '全部订单管理',
      path: '/content/:publicationId/order',
      component: OrderManage,
    },
    {
      name: '全部用户管理',
      path: '/content/:publicationId/user',
      component: UserManage,
    },
    {
      name: '作者详情',
      path: '/content/:publicationId/user/:uid',
      component: UserAuthor,
    },
    {
      name: '创建栏目',
      path: '/content/:publicationId/magazine/create',
      component: MagazineCreate,
    },
    {
      path: '/content/:publicationId/magazine/:magazineId',
      component: MagazineModule,
      children: [
        {
          name: '文章',
          path: '/content/:publicationId/magazine/:magazineId/',
          component: MagazineManage,
        },
        {
          name: '文章管理',
          path: '/content/:publicationId/magazine/:magazineId/article',
          component: MagazineManage,
        },
        {
          name: '主编管理',
          path: '/content/:publicationId/magazine/:magazineId/contributor',
          component: MagazineManage,
        },
        {
          name: '推广杂志',
          path: '/content/:publicationId/magazine/:magazineId/promotion',
          component: MagazineManage,
        },
        {
          name: '配置杂志',
          path: '/content/:publicationId/magazine/:magazineId/config',
          component: MagazineManage,
        },
        {
          name: '编辑杂志',
          path: '/content/:publicationId/magazine/:magazineId/edit',
          component: MagazineBasicManage,
        },
        {
          name: '内容管理',
          path: '/content/:publicationId/magazine/:magazineId/content',
          component: MagazineContentManage,
        },
        {
          name: '评论管理',
          path: '/content/:publicationId/magazine/:magazineId/comment',
          component: MagazineCommentManage,
        },
      ],
    },
    {
      name: '栏目分析',
      path: '/content/:publicationId/report',
      component: ReportPage,
    },
    {
      name: '品牌案例',
      path: '/content/:publicationId/brand',
      component: BrandCase,
    },
    {
      name: '主题',
      path: '/content/:publicationId/theme',
      component: ThemePage,
    },
    {
      name: '推广',
      path: '/content/:publicationId/promotion',
      component: PromotionPage,
    },
    {
      name: '素材库',
      path: '/content/:publicationId/resource',
      component: Resource,
    },
    {
      path: '/content/:publicationId/push',
      component: PushModule,
      children: [
        {
          name: '推送',
          path: '/content/:publicationId/push/',
          component: PushPage,
        },
        {
          name: '新建',
          path: '/content/:publicationId/push/new',
          component: PushNewPage,
        },
      ],
    },
    {
      name: '赚钱',
      path: '/content/:publicationId/ads',
      component: AdsPage,
    },
    {
      name: '商品',
      path: '/content/:publicationId/product',
      component: ProductPage,
    },
    {
      name: '表单',
      path: '/content/:publicationId/form',
      component: FormPage,
    },
    {
      name: '积分',
      path: '/content/:publicationId/score',
      component: ScorePage,
    },
    {
      name: '栏目设置',
      path: '/content/:publicationId/setting',
      component: SettingPage,
    },
  ],
}

export default contentPublicationRouter
